import { http } from '../services';

class AdminService {
    executaSQL(sql) {
        return http.post('/sql-admin', {
            sql,
        });
    }
}

const adminService = new AdminService();
export default adminService;
